<template>
  <v-form id="chart-filter-form" v-model="valid" ref="form" lazy-validation>
    <v-container fluid>
      <v-layout column wrap class="pb-2">
        <div>
          <h4>{{$t('dashboard.chart.title')}}</h4>
        </div>
        <v-flex xs12>
          <v-layout row justify-start>
            <v-text-field
              id="chart-filter-title-field"
              v-model="chartFilterTitle"
              class="mr-4 pt-1"
              clearable
              required
              :rules="requiredRule"
              :placeholder="$t('dashboard.chart.custom_name')">
            </v-text-field>
          </v-layout>
        </v-flex>
        <div>
          <h4>{{$t('dashboard.chart.date_range')}}
            <span v-if="flagRestrict4Weeks" class="caption">({{$t('dashboard.chart.date_range_restriction_info')}})</span>
          </h4>
        </div>
        <div class="chartFilterSelection">
          <v-flex xs12 sm12 px-2>
            <v-layout column class="align-start">
              <v-layout column>
                <v-layout row>
                  <v-flex xs12>
                    <date-range-picker :max-end="maxEnd"
                                       :max-start="maxStart"
                                       :now="null" :dateRange="dateRange"
                                       id="createChartFilter-date"
                                       @updated="updateDateRange" :start-disabled="startDateDisabled"
                                       :attach="true"
                                       :width="datePickerWidth"
                                       :vertical="true"
                                       :end-disabled="endDateDisabled"/>

                  </v-flex>
                </v-layout>
                <v-layout wrap row justify-space-between class="mt-2">
                  <v-btn v-if="isLastWeek" class="link" color="primary" @click="setLastWeekNumber(1)">{{$t('student_graph_last_week')}}</v-btn>
                  <v-btn v-else flat class="link" @click="setLastWeekNumber(1)">{{$t('student_graph_last_week')}}</v-btn>
                  <div class="button-bar"></div>
                  <v-btn v-if="isLast4Weeks" class="link" color="primary" @click="setLastWeekNumber(4)">{{$t('student_graph_last_4_weeks')}}</v-btn>
                  <v-btn v-else flat class="link" @click="setLastWeekNumber(4)">{{$t('student_graph_last_4_weeks')}}</v-btn>
                  <div v-if="!flagRestrict4Weeks" class="button-bar"></div>
                  <v-btn v-if="isLast10Weeks && !flagRestrict4Weeks" class="link" color="primary" @click="setLastWeekNumber(10)">{{$t('student_graph_last_10_weeks')}}</v-btn>
                  <v-btn v-else-if="!isLast10Weeks && !flagRestrict4Weeks" flat class="link" @click="setLastWeekNumber(10)">{{$t('student_graph_last_10_weeks')}}</v-btn>
                </v-layout>
              </v-layout>
            </v-layout>
          </v-flex>
        </div>
      </v-layout>
      <template>
        <div v-for="(type, keyType) in filteredChartFilterTypes" v-if="!type.isNotTutor">
          <div v-if="isEngagement(type.header) && flagDisplayAverageEngagementRating" class="engagement-filters">
            <h4 v-if="type.listName === 'myFilterIds' && flagDisplaySaveFilterForChart">{{$t(type.header)}}</h4>
            <h4 v-if="type.listName !== 'myFilterIds'" :class="[isDailyEngagement(type.header) && !flagDisplaySaveFilterForChart ? 'pt-3' : 'pt-2']">{{$t(type.header)}}</h4>

            <v-layout v-if="type.isList && type.listName !== 'myFilterIds'" row wrap>
              <filter-list
                :filter-type="keyType"
                @filter:list-change="filterListChangeInner"
                :source="listSources[type.listName]"
                :disabled="hideFilters"></filter-list>
            </v-layout>
            <v-layout v-else-if="type.isList && type.listName === 'myFilterIds' && flagDisplaySaveFilterForChart" row wrap>
              <my-filter-list
                :filter-type="keyType"
                @filter:list-change="filterListChangeInner"
                :source="listSources[type.listName]"
                :selected-filter-text="selectedFilterText"
                :show-delete-option="showDeleteOption"
                :show-default-option="showDefaultOption">
              </my-filter-list>
            </v-layout>
            <v-layout v-else row wrap>
              <filter-button v-for="(button, keyName) in type.values" :key="keyName" :text="button.text"
                             :filter-type="keyType" :filter-name="keyName"
                             :enabled="button.value"
                             @filter:click="filterChangeInner"
                             :icon="button.icon"
                             :disabled="hideFilters"/>
            </v-layout>
          </div>

          <div v-else class="pt-2">
            <h4 v-if="type.listName === 'myFilterIds' && flagDisplaySaveFilterForChart">{{$t(type.header)}}</h4>
            <h4 v-if="type.listName !== 'myFilterIds'">{{$t(type.header)}}</h4>

            <v-layout v-if="type.isList && type.listName !== 'myFilterIds'" row wrap>
              <filter-list
                :filter-type="keyType"
                @filter:list-change="filterListChangeInner"
                :source="listSources[type.listName]"
                :disabled="hideFilters"></filter-list>
            </v-layout>
            <v-layout v-else-if="type.isList && type.listName === 'myFilterIds' && flagDisplaySaveFilterForChart" row wrap>
              <my-filter-list
                :filter-type="keyType"
                @filter:list-change="filterListChangeInner"
                :source="listSources[type.listName]"
                :selected-filter-text="selectedFilterText"
                :show-delete-option="showDeleteOption"
                :show-default-option="showDefaultOption">
              </my-filter-list>
            </v-layout>
             <v-layout v-else row wrap>
              <filter-button v-for="(button, keyName) in type.values" :key="keyName" :text="button.text"
                             :filter-type="keyType" :filter-name="keyName"
                             :enabled="button.value"
                             @filter:click="filterChangeInner"
                             :icon="button.icon"
                             :disabled="hideFilters"/>
            </v-layout>
          </div>
        </div>
      </template>
      <v-layout row justify-center class="mt-4">
        <v-btn id="createChartFilter-cancel" @click="cancel">
          {{$t('cancel')}}
        </v-btn>
        <v-btn @click="createClicked"
               id="createChartFilter-create"
               color="primary"
               v-if="sendingShow">
          <span>{{$t('apply')}}</span>
        </v-btn>
      </v-layout>
    </v-container>
  </v-form>
</template>

<script>
  import moment from 'moment-es6'
  import DateRangePicker from '../date/DateRangePicker'
  import {mapMutations, mapState, mapActions, mapGetters} from 'vuex'
  import {
    SET_DRAWER_STATE,
    SET_UNDO_TYPE,
    SET_INFORMATION_SNACKBAR_STATE,
    SET_INFORMATION_SNACKBAR_TEXT,
    SET_CHART_FILTER_START_DATE,
    SET_CHART_FILTER_END_DATE,
    TOGGLE_CHARTS_LIST_FILTER,
    SET_CHARTS_LIST_FILTER_ARRAY,
    SET_CHART_LAST_WEEK_NUMBER,
    REFRESH_CHART_DATES,
    SET_CHART_START_DATE_FILTER, SET_CHART_END_DATE_FILTER, SET_CHART_UPDATED
  } from '../../store/mutation-types'
  import { informationTexts } from '../../store/modules/information'
  import FilterButton from '../filter/FilterButton'
  import FilterList from '../filter/FilterList'
  import MyFilterList from '../filter/MyFilterList'
  import {
    CLEAR_CHART_FILTERS_ACTION,
    GET_SAVED_FILTERS_FOR_CHARTS_ON_SELECTION,
    UPDATE_DASHBOARD_GRAPH_FILTERS
  } from '../../store/action-types'
  import { HAS_FEATURE_FLAG } from '../../store/getter-types'
  import VueScrollTo from 'vue-scrollto'

  export default {
    name: 'chart-filter-form',
    data () {
      return {
        valid: false,
        requiredRule: [v => !!v || this.$t('field_required'), v => (v && !this.nameExists(v)) || this.$t('filters.must_be_unique')],
        now: moment().format('YYYY-MM-DD'),
        sendingShow: true,
        selectedButtonObject: {},
        selectedButtonText: ''
      }
    },
    methods: {
      ...mapMutations({
        setUndoType: SET_UNDO_TYPE,
        setSnackBarText: SET_INFORMATION_SNACKBAR_TEXT,
        setSnackBar: SET_INFORMATION_SNACKBAR_STATE,
        filterChanged: TOGGLE_CHARTS_LIST_FILTER,
        filterListChange: SET_CHARTS_LIST_FILTER_ARRAY,
        refreshDates: REFRESH_CHART_DATES,
        setStartDate: SET_CHART_START_DATE_FILTER,
        setEndDate: SET_CHART_END_DATE_FILTER,
        setChartUpdated: SET_CHART_UPDATED
      }),
      ...mapActions({
        updateChartFilter: UPDATE_DASHBOARD_GRAPH_FILTERS,
        filterClear: CLEAR_CHART_FILTERS_ACTION,
        myFilterChange: GET_SAVED_FILTERS_FOR_CHARTS_ON_SELECTION
      }),
      updateDateRange (newDates) {
        // check if the start date has changed
        if (this.flagRestrict4Weeks && (this.startDate !== newDates.startDate)) {
          let newEnd = moment(newDates.startDate).add(this.daysRestricted, 'days').format('YYYY-MM-DD')
          // check if new start date (+ daysRestricted) is greater than today
          let diff = moment(this.now).diff(moment(newEnd), 'days')
          this.endDate = diff < 0 ? this.now : moment(newDates.startDate).add(this.daysRestricted, 'days').format('YYYY-MM-DD')
        } else {
          this.endDate = newDates.endDate
        }
        this.startDate = newDates.startDate
      },
      cancel () {
        this.$store.commit(SET_DRAWER_STATE, false)
        this.setSnackBarText(informationTexts.CREATE_CHART_FILTER_CANCELLED)
        this.setSnackBar(true)
        this.resetSelected()
      },
      createClicked () {
        if (this.$refs.form.validate() && !this.restriction) {
          this.setChartUpdated(false)

          let obj = this.isNew
            ? {title: this.title, defaultSearch: this.selectedButtonObject.defaultSearch}
            : {title: this.title, defaultSearch: this.selectedButtonObject.defaultSearch, id: this.selectedButtonObject.id}

          this.updateChartFilter(obj)
          this.$store.commit(SET_DRAWER_STATE, false)
          if (this.isNew) {
            this.setSnackBarText(informationTexts.CHART_UPDATED_WITH_NEW_FILTER)
          } else {
            this.setSnackBarText(informationTexts.CHART_FILTER_UPDATED)
          }
          this.setSnackBar(true)
          this.resetSelected()
        } else if (this.restriction) {
          // Makes the button wiggle around due to the animation associated with it
          this.sendingShow = false
          this.$nextTick(() => {
            this.sendingShow = true
          })
          let options = {
            container: '#right-drawer',
            easing: 'ease-in-out',
            offset: -64,
            cancelable: false
          }
          // scroll to date section
          VueScrollTo.scrollTo(this.$refs.form.getInputs()[1].$el, 500, options)
        } else {
          // Makes the button wiggle around due to the animation associated with it
          this.sendingShow = false
          this.$nextTick(() => {
            this.sendingShow = true
          })
          // Scroll to the first element with a validation error
          for (let i = 0; i < this.$refs.form.getInputs().length; i++) {
            if (this.$refs.form.getInputs()[i].hasError) {
              let options = {
                container: '#right-drawer',
                easing: 'ease-in-out',
                offset: -64,
                cancelable: false
              }
              VueScrollTo.scrollTo(this.$refs.form.getInputs()[i].$el, 500, options)
              break
            }
          }
        }
      },
      resetForm () {
        this.$nextTick(() => {
          this.$refs.form.inputs.forEach((input) => {
            input.shouldValidate = false
            input.isBooted = false
            input.hasFocused = false
          })
        })
      },
      selectedFilterText (filterObject) {
        this.selectedButtonObject = filterObject
        this.selectedButtonText = filterObject.title
        return filterObject
      },
      filterChangeInner (filterObject) {
        this.filterChanged(filterObject)
      },
      filterListChangeInner  (filterObject) {
        if (filterObject.filterType === 'myFilterIds') {
          if (filterObject.filterName.length === 0) {
            this.filterClear()
          } else {
            this.myFilterChange(filterObject)
          }
        } else {
          if (!this.disabled) {
            this.filterListChange(filterObject)
          }
        }
      },
      setLastWeekNumber (nDays) {
        let val
        if (nDays !== this.currentSelected) {
          val = nDays
          this.setStartDate(null)
          this.setEndDate(null)
        } else {
          val = -1
          this.refreshDates()
        }
        this.$store.commit(SET_CHART_LAST_WEEK_NUMBER, val)
      },
      nameExists (value) {
        return this.chartFilterTypes.myFilterIds.myFilters.map(el => el.description.toLowerCase()).includes(value.toLowerCase()) && this.isNew
      },
      resetSelected () {
        this.selectedButtonObject = {}
      },
      isEngagement (identifier) {
        return identifier.toString().includes('average') || identifier.toString().includes('engagement')
      },
      isDailyEngagement (identifier) {
        return identifier.toString().includes('engagement')
      }
    },
    computed: {
      title () {
        return this.selectedButtonText.length > 0 ? this.selectedButtonText : this.selectedButtonObject.title
      },
      isNew () {
        return this.title !== this.selectedButtonObject.title
      },
      filteredChartFilterTypes () {
        if (!this.flagDisplayAverageEngagementRating) {
          let obj = {}
          Object.keys(this.chartFilterTypes).forEach(el => {
            if (el !== 'averageEngagementRatings') {
              obj[el] = this.chartFilterTypes[el]
            }
          })
          return obj
        }
        return this.chartFilterTypes
      },
      ...mapState({
        startDateDisabled: state => state.dashboard.startDateDisabled,
        endDateDisabled: state => state.dashboard.endDateDisabled,
        lastWeekNumber: state => state.dashboard.lastWeekNumber,
        hideFilters: state => state.dashboard.hideFilters,
        chartFilterTypes: state => state.dashboard.chartFilterFields,
        listSources: state => state.dashboard.listSources,
        showDefaultOption: state => state.dashboard.showFilterDefaultOption,
        showDeleteOption: state => state.dashboard.showFilterDeleteOption,
        chartId: state => state.dashboard.selectedChartId,
        moduleStudent: state => state.profile.module.student,
        moduleInsights: state => state.profile.module.insights,
        functionMyStudent: state => state.students.functions.myStudents,
        functionChart: state => state.dashboard.functions.chart,
        optionEnableMyFilter: state => state.students.options.enable.myFilter,
        optionDisableDateRestriction: state => state.dashboard.options.disable.fourWeekRestriction,
        optionEnableAverageEngagement: state => state.students.options.enable.averageEngagement
      }),
      ...mapGetters({
        hasFeatureFlag: HAS_FEATURE_FLAG
      }),
      chartFilterTitle: {
        get () {
          return this.selectedButtonObject.title
        },
        set (value) {
          if ((value) && value.length > 0) {
            this.selectedButtonText = value
          }
        }
      },
      startDate: {
        get () {
          return this.$store.state.dashboard.startDate
        },
        set (value) {
          this.$store.commit(SET_CHART_FILTER_START_DATE, value)
        }
      },
      endDate: {
        get () {
          return this.$store.state.dashboard.endDate
        },
        set (value) {
          this.$store.commit(SET_CHART_FILTER_END_DATE, value)
        }
      },
      dateRange () {
        return {
          startDate: this.startDate,
          endDate: this.endDate
        }
      },
      flagDisplaySaveFilterForChart () {
        return this.hasFeatureFlag(this.moduleStudent + '.' + this.functionMyStudent + '.' + this.optionEnableMyFilter)
      },
      flagRestrict4Weeks () {
        return !this.hasFeatureFlag(this.moduleInsights + '.' + this.functionChart + '.' + this.optionDisableDateRestriction)
      },
      flagDisplayAverageEngagementRating () {
        return this.hasFeatureFlag(this.moduleStudent + '.' + this.functionMyStudent + '.' + this.optionEnableAverageEngagement)
      },
      noDates () {
        return this.lastWeekNumber > 0
      },
      isLastWeek () {
        return this.noDates && this.lastWeekNumber === 1
      },
      isLast4Weeks () {
        return this.noDates && this.lastWeekNumber === 4
      },
      isLast10Weeks () {
        return this.noDates && this.lastWeekNumber === 10
      },
      currentSelected () {
        return this.isLastWeek ? 1
         : this.isLast4Weeks ? 4
           : this.isLast10Weeks ? 10
             : -1
      },
      datePickerWidth () {
        return this.$vuetify.breakpoint.smAndUp ? 250 : 265
      },
      minStart () {
        return null
      },
      maxStart () {
        return this.now
      },
      minEnd () {
        return this.startDate
      },
      maxEnd () {
        return this.nowRestriction ? moment(this.startDate).add(this.daysRestricted, 'days').format('YYYY-MM-DD') : this.now
      },
      nowRestriction () {
        return this.flagRestrict4Weeks && moment(this.now).diff(moment(this.startDate), 'days') > this.daysRestricted
      },
      restriction () {
        return this.flagRestrict4Weeks && moment(this.endDate).diff(moment(this.startDate), 'days') > this.daysRestricted
      },
      daysRestricted () {
        return this.flagRestrict4Weeks ? 28 : 0
      }
    },
    components: {
      DateRangePicker,
      FilterButton,
      FilterList,
      MyFilterList
    }
  }
</script>

<style scoped>
  .button-bar {
    display: inline-block;
    height: 28px;
    border-right: 2px solid lightgray;
    margin: 5px 0px 0px 0px;
  }

  button.link.btn {
    text-decoration: underline;
    text-transform: none;
  }

  @media (min-width: 600px) and (max-width: 1200px) {
    .chartFilterSelection .link {
      font-size: 11px;
    }
  }

  @media (max-width: 1200px) {
    .chartFilterSelection .link {
      min-width: 80px;
      font-size: 10px;
    }
  }

  @media only screen and (min-width: 1904px) {
    .engagement-filters {
      width: 176px;
      float: left;
    }
  }
</style>

<style>
  .chartFilterSelection .link {
    margin: 0px;
  }

  .chartFilterSelection .link .btn__content {
    padding-left: 8px;
    padding-right: 8px;
  }
</style>



// WEBPACK FOOTER //
// src/components/dashboard/ChartFilterForm.vue